<template>
  <div class="login-container login-erea">
    <el-form
      autoComplete="on"
      :model="loginForm"
      :rules="loginRules"
      ref="loginForm"
      label-position="left"
      label-width="0px"
      class="card-box login-form">
      <h3 class="title">音像电子出版单位年度核验管理系统</h3>
      <el-form-item prop="account">
        <!-- <span class="svg-container">
                    <icon-svg icon-class="jiedianyoujian"></icon-svg>
                </span> -->
        <el-input
          prefix-icon="el-icon-edit"
          name="mobilePhone"
          type="text"
          v-model="loginForm.account"
          autoComplete="off"
          placeholder="单位名称"></el-input>
      </el-form-item>
      <el-form-item prop="pwd">
        <!-- <span class="svg-container">
                    <icon-svg icon-class="mima" ></icon-svg>
                </span> -->
        <el-input
          v-model="loginForm.pwd"
          :type="typePwd"
          prefix-icon="el-icon-edit"
          name="password"
          @keyup.enter.native="handleLogin"
          autoComplete="off"
          placeholder="密码"></el-input>
        <img
          :src="imgPwd"
          alt="密码"
          @click="showPwd()"
          :hidden="!imgPwdShow"
          style="position: absolute; width: 30px; height: 30px; top: 5px; right: 5px; cursor: pointer" />
      </el-form-item>
      <el-form-item prop="imgCode">
        <el-input class="imgCode" autoComplete="off" v-model="loginForm.imgCode" placeholder="验证码"></el-input>
        <div class="imgbox">
          <img :src="imgUrl" @click="imgChange" />
        </div>
      </el-form-item>
      <el-form-item class="login-bx">
        <el-button type="primary" style="width: 100%" :loading="loading" @click="handleLogin"> 登录 </el-button>
      </el-form-item>

      <div v-if="isShowChromeTip" style="color: red; font-size: 15px; text-align: center">
        请务必使用360浏览器极速模式打开【<a target="_blank" href="http://down.360safe.com/se/360se10.0.1250.0.exe"
          >点击下载</a
        >】
      </div>
      <div class="login-tip">
        工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。
      </div>
    </el-form>
  </div>
</template>

<script>
import { isWscnEmail } from "@/utils/validate";
import { setToken, setCookie, getCookie } from "@/utils/auth";
import { uuid } from "@/utils/uuid";
import pwd_hide from "@/assets/input_pwd/hide.png";
import pwd_show from "@/assets/input_pwd/show.png";

export default {
  name: "login",
  data() {
    const validateMobilePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("密码不能小于8位"));
      } else {
        callback();
      }
    };

    return {
      imgUrl: "",
      loginForm: {
        account: "",
        pwd: "",
        imgCode: "",
      },
      loginRules: {
        account: [{ required: true, trigger: "blur", validator: validateMobilePhone }],
        pwd: [{ required: true, trigger: "blur", validator: validatePass }],
        imgCode: [{ required: true, trigger: "blur", message: "验证码不能为空" }],
      },
      loading: false,
      pwd_hide,
      pwd_show,
      imgPwd: pwd_show,
      typePwd: "password",
      imgPwdShow: true,
    };
  },
  computed: {
    isShowChromeTip() {
      var browser = this.checkBrowser();
      var flag = false;
      if (browser != "Chrome") {
        flag = true;
      }
      // console.log(browser);
      return flag;
    },
  },
  methods: {
    handleLogin() {
      // console.warn('handleLogin');
      if (!this.isShowChromeTip) {
        this.loading = true;
        this.$store
          .dispatch("Login", this.loginForm)
          .then((state) => {
            // console.warn('dispatch(Login: ', state)
            this.loading = false;
            if (state == 2) {
              this.$router.push({ path: "/paddSet" });
            } else if (state == 1) {
              this.$router.push({ path: "/" });
            }
          })
          .catch(() => {
            this.loading = false;
            this.imgChange();
          });
      } else {
        this.$message.error("请使用360浏览器极速模式，或谷歌浏览器打开！");
      }
    },
    showPwd() {
      if (this.typePwd === "password") {
        this.typePwd = "text";
        this.imgPwd = pwd_hide;
      } else {
        this.typePwd = "password";
        this.imgPwd = pwd_show;
      }
    },

    imgChange: function () {
      var newTime = Date.parse(new Date());
      // this.imgUrl = process.env.BASE_API + "/User/User/getVerifyImg?t=" + uuid() + newTime;
      this.imgUrl = process.env.BASE_API + "/auth/getVerifyImg?t=" + uuid() + newTime;
    },

    checkBrowser: function () {
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      var isOpera = userAgent.indexOf("Opera") > -1;
      if (isOpera) {
        return "Opera";
      } //判断是否Opera浏览器
      if (userAgent.indexOf("Firefox") > -1) {
        return "FF";
      } //判断是否Firefox浏览器
      if (userAgent.indexOf("Chrome") > -1) {
        return "Chrome";
      }
      if (userAgent.indexOf("Safari") > -1) {
        return "Safari";
      } //判断是否Safari浏览器
      if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
        return "IE";
      } //判断是否IE浏览器
    },
  },

  created: function () {
    this.imgChange();
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
@import "src/styles/mixin.scss";
.login-tip {
  width: 800px;
  margin-left: -230px;
  text-align: center;
  color: #ff6666;
  font-size: 14px;
}
.login-container {
  @include relative;
  height: 100vh;
  background-color: #2d3a4b;

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 5px;
  }

  .title {
    font-size: 26px;
    font-weight: 400;
    width: 600px;
    color: #eeeeee;
    margin: 0px auto 30px auto;
    text-align: center;
    margin-left: -130px;
    font-weight: bold;
  }

  .login-form {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 340px;
    height: 320px;
    margin-left: -170px;
    margin-top: -240px;
  }

  .el-form-item {
    margin-bottom: 24px;
  }

  .el-input input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #293444 inset !important;
    -webkit-text-fill-color: #fff !important;
    background: transparent !important;
  }

  .el-input input {
    background: rgba(0, 0, 0, 0.1) !important;
    color: #eeeeee;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
  }

  input {
    background: transparent;
    border: 0px;
    -webkit-appearance: none;
  }

  .login-bx {
    margin-top: 30px;
  }

  .imgCode {
    width: 200px;
  }

  .imgbox {
    width: 120px;
    height: 40px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 5px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.1);
    cursor: pointer;
    float: right;
  }

  .imgbox img {
    width: 120px;
    height: 40px;
  }

  // input:-webkit-autofill {
  //   -webkit-box-shadow: 0 0 0px 1000px #293444 inset !important;
  //   -webkit-text-fill-color: #fff !important;
  // }
  // input {
  //   background: transparent;
  //   border: 0px;
  //   -webkit-appearance: none;
  //   border-radius: 0px;
  //   padding: 12px 5px 12px 15px;
  //   color: #eeeeee;
  //   height: 47px;
  // }
  // .login-container .el-input {
  //   display: inline-block;
  //
  // }
  // .svg-container {
  //   padding: 6px 5px 6px 15px;
  //   color: #889aa4;
  // }
  // .title {
  //   font-size: 26px;
  //   font-weight: 400;
  //   width: 600px;
  //   color: #eeeeee;
  //   margin: 0px auto 40px auto;
  //   text-align: center;
  //   margin-left: -130px;
  //   font-weight: bold;
  // }
  // .login-form {
  //   position: absolute;
  //   left: 0;
  //   right: 0;
  //   width: 340px;
  //   margin: 120px auto;
  // }
  // .el-form-item {
  //   // border: 1px solid rgba(255, 255, 255, 0.1);
  //   // background: rgba(0, 0, 0, 0.1);
  //   border-radius: 5px;
  //   color: #454545;
  // }
  // .forget-pwd {
  //   color: #fff;
  // }
  //
  // .imgCode.el-input{
  //     width: 120px;
  // }
}
</style>



// WEBPACK FOOTER //
// login.vue?3408be5c